import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import styled from 'styled-components'

import { Wrapper, Button } from 'react-aria-menubutton';
import Tile from '../../Tile';
import BubbleMenu from '../../BubbleMenu';

const Container = styled.div`
    position: relative;

    > h3 {

        font-family: Lato-Regular;
        font-size: 12px;
        font-weight: normal;

        color: #666666;
        line-height: 16px;
        margin: 0;
        margin-bottom: 8px;
        margin-top: 12px;
    }

    div[role=menu] {
        right: -15px;
        top: 65px;
        width: 189px;
        height: auto;

        > ul {
            > li {
                text-align: center;
                padding: 20px 0 17px 0;
            }
        }

        &.down:before, &.down:after {
            left: 75%;
        }
    }
`

export class VestingVestedAward extends Component {

    getEventsMenuOptions = (t) => {
        var options = []
        if(this.props.events){
            var len = this.props.events.length;
            if(len > 0){
                for(var index  = 0; index < len; index++){
                    var event = this.props.events[index];
                    var value = t("VestingSummary.NextVestEventRow", {award_name: event.award_name, share_quatity: event.share_quantity })
                    options.push({value: index, label: value})
                }
            }
        }
        return options
    }

    onTileClicked = () => {
        this.onSelectMenuItem(0);
    }

    onSelectMenuItem = (index) =>{
        var event = this.props.events[index];
        this.props.selectVestEvent(event.award_id, event.vest_id, event.transaction_id)
    }

    render() {
        const { theme, t } = this.props;
        const hasEvents = this.props.events && this.props.events.length > 1;
        const hasOnlyOneEvent = this.props.events && this.props.events.length === 1;
        const headerButtonLabel = hasEvents ? t('VestingSummary.EventButtonText', {number_events: this.props.events.length }) : null;

        return (
            <Container className={this.props.className}>
                {this.props.title &&
                    <h3>{this.props.title}</h3>
                }
                {!hasEvents &&
                    <Tile date={this.props.date}
                        headerButtonLabel={headerButtonLabel}
                        isClickable={this.props.onTileClicked  || hasOnlyOneEvent ? true : false}
                        info={this.props.info}
                        footerTop={this.props.footerTop}
                        footerMid={this.props.footerMid}
                        footerBottom={this.props.footerBottom}
                        footerMidLabel={t('VestingSummary.TaxBrokerLabel')}
                        footerBottomLabel={t('VestingSummary.NetBrokerLabel')}
                        footer={this.props.footer}
                        onTileClicked={hasOnlyOneEvent ? this.onTileClicked : this.props.onTileClicked}
                        obj={this.props.obj}
                        theme={theme}/>
                }
                {hasEvents &&
                    <Wrapper onSelection={this.onSelectMenuItem.bind(this)}>
                        <Button>
                            <Tile date={this.props.date}
                                headerButtonLabel={headerButtonLabel}
                                isClickable={true}
                                info={this.props.info}
                                footerTop={this.props.footerTop}
                                footerMid={this.props.footerMid}
                                footerBottom={this.props.footerBottom}
                                footerMidLabel={t('VestingSummary.TaxBrokerLabel')}
                                footerBottomLabel={t('VestingSummary.NetBrokerLabel')}
                                footer={this.props.footer}
                                theme={theme}/>
                        </Button>
                        <BubbleMenu
                            arrow="down"
                            options={this.getEventsMenuOptions(t)}/>
                    </Wrapper>
                }
            </Container>
        )
    }
  }

  export default withTranslation('translations')(VestingVestedAward);
